exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menuItemTitle {\n  color: var(--headbandTextColor) !important;\n}\n.panelBackground {\n  background-color: var(--headbandColor);\n  -webkit-box-shadow: 1px 0px 5px grey;\n          box-shadow: 1px 0px 5px grey;\n  max-width: 255px;\n  overflow-x: hidden;\n  width: 75%;\n}\n.profileInformationContainer {\n  color: white;\n}\n.subMenuItem {\n  color: var(--headbandTextColor);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9181714e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/menus/MobileLeftPanel.vue
// module id = 1594
// module chunks = 2